import { useTranslation } from "react-i18next";

export default function Result({ successMessage, backgroundColor, isMobile }) {
  const { t } = useTranslation();

  return (
    <div className={`flex flex-col items-center justify-center successMessage h-full relative ${isMobile ? "" : "mx-40"}`}>
      <svg
        width="100"
        height="100"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M51.051 84.551C32.602 84.551 17.551 69.5 17.551 51.051C17.551 32.602 32.602 17.551 51.051 17.551C69.5 17.551 84.551 32.602 84.551 51.051C84.551 69.5 69.5 84.551 51.051 84.551ZM51.051 20.051C33.949 20.051 20.051 33.949 20.051 51.051C20.051 68.153 33.949 82.051 51.051 82.051C68.153 82.051 82.051 68.153 82.051 51.051C82.051 33.949 68.102 20.051 51.051 20.051Z"
          fill="#2764EB"
        />
        <path
          d="M48.398 65.648C48.0464 65.648 47.7495 65.4996 47.4995 65.2964L31.9485 49.7494C31.4485 49.2494 31.4485 48.4486 31.9485 47.9994C32.4485 47.4994 33.2493 47.4994 33.6985 47.9994L48.3465 62.6474L77.4945 33.4484C77.9945 32.9484 78.7953 32.9484 79.2445 33.4484C79.7445 33.9484 79.7445 34.7492 79.2445 35.1984L49.1935 65.3004C49.049 65.5504 48.6975 65.6481 48.3967 65.6481L48.398 65.648Z"
          fill="#2764EB"
        />
      </svg>

      <div style={{ fontSize: "22px" }} className="font-semibold mt-2">
        {t("thank_you")}!
      </div>
      {successMessage?.length > 0 ? (
        <div
          className="text-center mt-4"
          style={{ fontWeight: 500, fontSize: "16px" }}
          dangerouslySetInnerHTML={{ __html: successMessage }}
        ></div>
      ) : (
          <div className="text-center" style={{ fontWeight: 500, fontSize: "16px" }}>
            <div className="mt-4">
              {t("lead.formSubmissionMessages.coordinator")}
            </div>
            <div className="mt-4">
              {t("lead.formSubmissionMessages.availability")}
            </div>
          <div className="mt-4">{t("lead.formSubmissionMessages.phone")}: 310.905.6848</div>
        </div>
      )}
    </div>
  );
}
